exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#CameraApp{margin:20px auto;max-width:1200px;position:relative}#CameraApp .cameraApp-content{box-shadow:0 3px 6px rgba(0,0,0,.16),0 3px 6px rgba(0,0,0,.23);overflow:hidden;display:grid}#CameraApp .visual-editor{position:relative;height:500px;display:flex;justify-content:center;align-items:center;overflow:hidden}#CameraApp .visual-editor img{height:100%;z-index:1}#CameraApp video{position:absolute;height:100%}#CameraApp video.front{-webkit-transform:scaleX(-1);transform:scaleX(-1)}#CameraApp .editor-canvas{position:absolute;height:100%}#CameraApp .circle-btn{position:absolute;z-index:10;bottom:0;margin:10px;width:75px;height:75px}#CameraApp .circle-btn img{width:90%}#CameraApp .circle-btn.right{right:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-666a3c39","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/CameraApp.vue
// module id = 33
// module chunks = 0